/* 
  系统管理-用户管理
*/
import request from "@/utils/request";

/* ---------------------------------用户管理页面左侧机构树------------------------------------------ */
// 获取所有机构树 /baseOrg/allOrgTreeList
export const getAllOrgTreeList = () => {
  return request({
    url: `/baseOrg/allOrgTreeList`,
    method: "get"
  });
};

// /baseOrg/allOrgLevelList  获取所有机构层级
export const getAllOrgLevelList = () => {
  return request({
    url: `/baseOrg/allOrgLevelList`,
    method: "get"
  });
};
// /baseOrg/get/{orgId} 根据机构id查询机构
export const getOrgByOrgId = (orgId: string) => {
  return request({
    url: `/baseOrg/get/${orgId}`,
    method: "get"
  });
};
// /baseOrg 新增机构
export const postBaseOrg = (baseOrgForm: object) => {
  return request({
    url: `/baseOrg`,
    method: "post",
    data: baseOrgForm
  });
};
// /baseOrg/{orgId} 修改机构 orgId 机构id
export const putBaseOrgByOrgId = (orgId: string, baseOrgForm: object) => {
  return request({
    url: `/baseOrg/${orgId}`,
    method: "put",
    data: baseOrgForm
  });
};
// /baseOrg/{orgId} 删除机构  orgId 机构id
export const delBaseOrgByOrgId = (orgId: string) => {
  return request({
    url: `/baseOrg/${orgId}`,
    method: "delete"
  });
};

/* ---------------------------------用户管理页面右侧用户表格------------------------------------------ */

// /baseUser/getPage/{orgId} 获取用户分页列表
export const getPageByOrgId = (orgId: string, baseUserQueryForm: object) => {
  return request({
    url: `/baseUser/getPage/${orgId}`,
    method: "post",
    data: baseUserQueryForm
  });
};
// /baseUser/{orgId} 新增用户
export const postBaseUserByOrgId = (orgId: string, baseUserForm: object) => {
  return request({
    url: `/baseUser/${orgId}`,
    method: "post",
    data: baseUserForm
  });
};
// /baseUser/{id} 修改用户 id 用户id    baseUserForm  用户实体
export const putBaseUserById = (id: string, baseUserForm: object) => {
  return request({
    url: `/baseUser/${id}`,
    method: "put",
    data: baseUserForm
  });
};
// /baseUser/batchDel/ 批量删除用户
export const delBaseUserByIds = (ids: Array<string>) => {
  return request({
    url: `/baseUser/batchDel/`,
    method: "delete",
    data: ids
  });
};

// 获取所有用户类型
export const queryAllUserTypes = () => {
  return request({
    url: `/baseUser/queryAllUserTypes`,
    method: "get"
  });
};
